import React from 'react';

import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const moveInChecklistForm: Form<Client> = {
  key: 'moveInChecklist',
  title: 'Checkliste zum Einzug einer Frau',
  fields: [
    {
      key: 'houseTour',
      label: 'Kurze Hausführung',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'movingInJobCenterNotification',
      label: <b>Einzugstag: Anmeldung Jobcenter per E-Mail</b>,
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'movingInEaServiceNotification',
      label: 'Einzugstag: EA-Dienst & Pfortenkraft informieren',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'scannedId',
      label: 'Ausweis / Aufenthaltstitel eingescannt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },

    {
      key: 'instructionEmergencyExits',
      label: 'Einweisung Schleuse und Notausgänge',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'emergencyNumbersDiscussed',
      label: 'Notfallnummern besprochen',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'explanationReportingRequirement',
      label: 'Rückmeldepflicht vor 22 Uhr erklärt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'profileForGateAttendants',
      label: 'Steckbrief für Pfortenkräfte angelegt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'moveInAdministrationNotification',
      label: 'Info an Verwaltung',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'securityDepositPaid',
      label: 'Kaution bezahlt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'signUpDonation',
      label: 'Einzugsspende',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'securityPlanDiscussed',
      label: 'Sicherheitskonzept besprochen',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'residentFolderDistributed',
      label: 'Bewohnerinnenordner herausgegeben',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'appointmentHM',
      label: 'Termin HM vereinbart',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: '',
      label: 'Originale unterschrieben:',
      fieldTypes: 'headline',
    },
    {
      key: 'waiverOfConfidentiality',
      label: 'Schweigepflichtentbidnung',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'residenceAgreement',
      label: 'Aufenthaltsvereinbarung',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'chipDistribution',
      label: 'Chip-Herausgabe',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'leaseAgreement',
      label: 'Mietvertrag',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'rentalCellPhoneContract',
      label: 'bei Bedarf Leihhandy-Vertrag',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: '',
      label: 'Ehemalige Wohnung',
      fieldTypes: 'headline',
    },
    {
      key: 'terminateLease',
      label: 'Wohnung kündigen',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'cancelUtilityBills',
      label: 'Strom/Wasser/Telefon',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'cancelGez',
      label: 'GEZ',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'eaRegistration',
      label: 'Anmeldung EA',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'changeOfAddress',
      label: 'Adressänderung',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
  ],
};

export default moveInChecklistForm;
